module.exports = __webpack_public_path__ + "media/images/pic/banners/sing-up-d39e485392b7b1a722136d7206d036ed.jpeg";